export enum InsuranceFields {
  APPLICATION_NUMBER = "Application number",
  INSURANCE_NUMBER = "Insurance number",
  KIND_OF_INSURANCE = "Kind of insurance",
  INSURANCE_COMPANY = "Insurance company",
  INSURANCE_PREMIUM = "Insurance premium",
  CURRENCY = "Currency",
  MARINE_SURVEYOR = "Name of  Marine Surveyor in case of damage",
}

export type InsuranceResponse = {
  id: number;
  application_id: number | null;
  insurance_policy_number: number | null;
  insurance_type: string | null;
  insurer_name: string | null;
  premium_amount: number | null;
  damage_surveyor: string | null;
  currency: string | null;
  comment: string | null;
};

export type CreateInsuranceRequest = CreateInsuranceFields & {
  shipping_case_id: number;
};

export type ShippingCaseInsurances = InsuranceResponse[];
export type ShippingCaseInsurancesRespose = {
  items: ShippingCaseInsurances;
  total: number;
  size: number;
  pages: number;
  page: number;
};

export type CreateInsuranceFields = {
  application_id: string | null;
  insurance_policy_number: string | null;
  insurance_type: string | null;
  insurer_name: string | null;
  premium_amount: number | null;
  damage_surveyor: string | null;
  currency: string | null;
  comment: string | null;
} | null;
